import {isPartiallySupportedLocale, Locale} from '@/utils/constants'
import {useLanguage} from '@/utils/i18n/language'

export const useImageLocale = () => {
  const language = useLanguage()
  return getImageLocale(language)
}

export const getImageLocale = (locale: Locale) =>
  !locale || locale === Locale.es || isPartiallySupportedLocale(locale) ? Locale.en : locale
